// shared.service.ts
import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private emailStepNameSubject = new Subject<string>();
  emailStepName$ = this.emailStepNameSubject.asObservable();

  private editMode1Source = new Subject<boolean>();
  editMode1$ = this.editMode1Source.asObservable();
  // private editMode3Source = new BehaviorSubject<boolean>(false);
  // editMode3$ = this.editMode3Source.asObservable();

  private editMode2Source = new Subject<boolean>();
  editMode2$ = this.editMode2Source.asObservable();

  private editFormData1Subject = new BehaviorSubject<any>({});
  editFormData1$ = this.editFormData1Subject.asObservable();

  private editFormData2Subject = new BehaviorSubject<any>({});
  editFormData2$ = this.editFormData2Subject.asObservable();
  private openedStep1 = new BehaviorSubject<any>({});
  stageOpened1$ = this.openedStep1.asObservable();
  private openedStep2 = new BehaviorSubject<any>({});
  stageOpened2$ = this.openedStep2.asObservable();

  private activeFormSource = new BehaviorSubject<number>(1);
  activeForm$ = this.activeFormSource.asObservable();



  private ActiveStageSource = new Subject<number>();
  activeStage$ = this.ActiveStageSource.asObservable();

  private isCalledFromBulkReveal = new Subject<boolean>(); 

  constructor() {
    // Set default values in the constructor
    this.setEditMode(false,1);
    this.setEditMode(false,2);
    this.setEditMode(false,0);
    this.setActiveForm(1);
    this.setOpened(false, 1);
    this.setOpened(false, 2);
  }

  setActiveForm(activeForm: number) {
    //console.log("activeForm service", activeForm)
    this.activeFormSource.next(activeForm);
  }
  

  updateEmailStepName(value: string) {
    this.emailStepNameSubject.next(value);
  }

  getEmailStepName(): Observable<string> {
    return this.emailStepName$;
  }

  setEditMode(editMode: boolean, editFormNumber: number) {
    if (editFormNumber === 1) {
      this.editMode1Source.next(editMode);
    } else if (editFormNumber === 2) {
      this.editMode2Source.next(editMode);
    }
    // else if (editFormNumber === 0) {
    //   this.editMode3Source.next(editMode);
    // }
    

  }
  setOpened(editMode: boolean, stage: number) {
    if (stage === 1) {
      this.openedStep1.next(editMode);
    } else if (stage === 2) {
      this.openedStep2.next(editMode);
    }
  }

  updateEditFormData(formData: any, editFormNumber: number) {
    if (editFormNumber === 1) {
      this.editFormData1Subject.next(formData);
    } else if (editFormNumber === 2) {
      this.editFormData2Subject.next(formData);
    }
  }

  private startCampaignSource = new BehaviorSubject<void>(null);
  startCampaign$ = this.startCampaignSource.asObservable();

  emitStartCampaign() {
    this.startCampaignSource.next(undefined as any);
  }
  //return true if any of the form is in edit mode
  isInEditMode(){
    return this.editMode1$ || this.editMode2$;
  }
  

  setDefault(){
    this.setEditMode(false,1);
    this.setEditMode(false,2);
    this.setEditMode(false,0);
    this.setActiveForm(1);
    this.setOpened(false, 1);
    this.setOpened(false, 2);
  }
  setActiveStage(activeForm: number) {
    this.ActiveStageSource.next(activeForm);
  }

}
